const separator = "--++--"

export default class SettingRepository {
    static save(group, id, value) {
        localStorage.setItem(group + separator + id, value)
    }

    static get(group, id) {
        return localStorage.getItem(group + separator + id)
    }

    static getInt(group, id, defult) {
        const s = localStorage.getItem(group + separator + id)

        if (!s || isNaN(parseInt(s))) return defult
        else return parseInt(s)
    }
}